import { createAction } from '@reduxjs/toolkit';

export const restoreWhiteboardRequested = createAction('whiteboardDrafts/restoreRequested');
